import { FeatureLogger } from "../utils/feature-logger";

const name = "acton-form-tracking";

export const logger = new FeatureLogger(name);
